import React from "react";
import { ArrowLeft, Sparkles, Calendar } from "lucide-react";

const RecipeTopNav = ({ onBack, onForkAction, onPlan, onEdit, recipe }) => {
    return (
        <div className={`d-flex align-items-center justify-content-between mb-3 px-4 flex-shrink-0 sticky-top bg-white py-2 z-2 border-bottom`}>
            <button className="btn btn-link text-decoration-none text-muted d-flex align-items-center gap-2 px-0 hover-opacity-75" onClick={onBack}>
                <ArrowLeft size={20} /> <span className="fw-medium font-sans">Zurück zur Übersicht</span>
            </button>
            <div className="d-flex gap-2">

                <button className="btn btn-light rounded-pill px-3 d-flex align-items-center gap-2 text-muted" onClick={onForkAction} title="Rezept anpassen (Kopie erstellen)">
                    <Sparkles size={18} />
                </button>
                {onPlan && (
                    <button
                        className="btn btn-primary rounded-pill px-3 d-flex align-items-center gap-2 fw-medium font-sans shadow-sm"
                        onClick={onPlan}
                    >
                        <Calendar size={18} /> <span>Einplanen</span>
                    </button>
                )}
                {recipe.isOwner && !(recipe.publicationDate && (recipe.editorialStatus === 'pending' || recipe.editorialStatus === 'approved')) && (
                    <button className="btn btn-primary rounded-pill px-4 fw-medium font-sans shadow-sm" onClick={onEdit}>
                        Rezept bearbeiten
                    </button>
                )}
            </div>
        </div>
    );
};

export default RecipeTopNav;
